import React from 'react';
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';

const Cutting = (props) => (
  <QuoteBuilderForm
    config={props.config.cutting}
    disabled={props.disabled}
    disabledReason={props.disabledReason}
    options={props.options}
    section_uuid={props.uuid}
    navSectionColumnType={props.navSectionColumnType}
    item={props.item}
    extra_title={props.extra_item_title}
    navSection={props.navSection}
    columnTitle={props.columnTitle}
    colIndex={props.colIndex}
    rowIndex={props.rowIndex}
    getExtraItems={props.getExtraItems}
    readOnly={window.user_quote_finalised}
  />
);

export default Cutting;